import React from "react";
import { useUserContext } from "context/UserContext";
import EmployeeManagementBK from "layouts/BK/employee";
import { isBkLikeRole } from "utils/roleUtils";

function EmployeeManagement() {
  const { role } = useUserContext() || {};
  if (isBkLikeRole(role)) {
    return <EmployeeManagementBK />;
  }
  return null;
}

export default EmployeeManagement;
